<message-display
  [heading]="'Uh oh !'"
  [subHeading]="'An error has occured.'"
  [link]="'/scopes'"
  [linkName]="'My Scopes'"></message-display>
